import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { TooltipIcon } from '../icons';
export var defaultTooltipTriggerStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin: 0 5px;\n"])));
export var StyledTooltipIcon = styled(TooltipIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tvertical-align: -2px;\n"])));